import { makeObservable, observable } from 'mobx';
import { AccountStore } from './accountStore';
import { AdjustmentStore } from './adjustmentStore';
import { AdvanceStore } from './advanceStore';
import { AlertStore } from './alertStore';
import { AssetStore } from './assetStore';
import { BulkStore } from './bulkStore';
import { CompanyStore } from './companyStore';
import { DateStore } from './dateStore';
import { FilterStore } from './filterStore';
import { HeaderStore } from './headerStore';
import { HeadlinesStore, LenderStatementHeadlinesStore, StatementHeadlinesStore } from './headlines';
import { LenderStore } from './lenderStore';
import { LoanStore } from './loanStore';
import { MenuStore } from './menuStore';
import { ParticipationStore } from './participationStore';
import { PaymentStore } from './paymentStore';
import { StatementStore } from './statementStore';
import { TransactionStore } from './transactions';
import { LenderStatementTransactionsStore } from './transactions/lenderStatementTransactionsStore';
import { StatementTransactionsStore } from './transactions/statementTransactionsStore';
import { UserStore } from './userStore';

export class RootStore {
  userStore: UserStore;
  menuStore: MenuStore;
  accountStore: AccountStore;
  advanceStore: AdvanceStore;
  assetStore: AssetStore;
  adjustmentStore: AdjustmentStore;
  bulkStore: BulkStore;
  companyStore: CompanyStore;
  dateStore: DateStore;
  filterStore: FilterStore;
  lenderStore: LenderStore;
  loanStore: LoanStore;
  participationStore: ParticipationStore;
  paymentStore: PaymentStore;
  headlinesStore: HeadlinesStore;
  statementHeadlinesStore: StatementHeadlinesStore;
  lenderStatementHeadlinesStore: LenderStatementHeadlinesStore;
  transactionStore: TransactionStore;
  statementTransactionsStore: StatementTransactionsStore;
  lenderStatementTransactionsStore: LenderStatementTransactionsStore;
  statementStore: StatementStore;
  alertStore: AlertStore;
  headerStore: HeaderStore;

  constructor() {
    this.userStore = new UserStore(this);
    this.menuStore = new MenuStore(this);
    this.accountStore = new AccountStore(this);
    this.advanceStore = new AdvanceStore(this);
    this.assetStore = new AssetStore(this);
    this.adjustmentStore = new AdjustmentStore(this);
    this.bulkStore = new BulkStore(this);
    this.companyStore = new CompanyStore(this);
    this.dateStore = new DateStore(this);
    this.lenderStore = new LenderStore(this);
    this.loanStore = new LoanStore(this);
    this.filterStore = new FilterStore(this);
    this.participationStore = new ParticipationStore(this);
    this.paymentStore = new PaymentStore(this);
    this.headlinesStore = new HeadlinesStore(this);
    this.statementHeadlinesStore = new StatementHeadlinesStore(this);
    this.lenderStatementHeadlinesStore = new LenderStatementHeadlinesStore(this);
    this.transactionStore = new TransactionStore(this);
    this.statementTransactionsStore = new StatementTransactionsStore(this);
    this.lenderStatementTransactionsStore = new LenderStatementTransactionsStore(this);
    this.statementStore = new StatementStore(this);
    this.alertStore = new AlertStore(this);
    this.headerStore = new HeaderStore(this);

    makeObservable(this, {
      userStore: observable,
      menuStore: observable,
      accountStore: observable,
      advanceStore: observable,
      assetStore: observable,
      adjustmentStore: observable,
      bulkStore: observable,
      companyStore: observable,
      dateStore: observable,
      filterStore: observable,
      lenderStore: observable,
      loanStore: observable,
      participationStore: observable,
      paymentStore: observable,
      headlinesStore: observable,
      statementHeadlinesStore: observable,
      lenderStatementHeadlinesStore: observable,
      transactionStore: observable,
      statementTransactionsStore: observable,
      lenderStatementTransactionsStore: observable,
      statementStore: observable,
      alertStore: observable,
      headerStore: observable,
    });
  }
}
